import { render, staticRenderFns } from "./HeistaItemImage.vue?vue&type=template&id=2dfe5479&"
import script from "./HeistaItemImage.vue?vue&type=script&lang=js&"
export * from "./HeistaItemImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports